import React, { useEffect, useState } from 'react';

import { useRouter } from 'next/router';
import AppleSignin from 'react-apple-signin-auth';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'; // special import for custom icon see library docs
import { GoogleLogin } from 'react-google-login';
import { useToasts } from 'react-toast-notifications';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import AuthService from '@services/domain/Lpc/AuthService';
import { getRoute, ROUTE } from '@services/http/Route';
import { getItemFromStorage } from '@services/utils/StorageService';

import css from './SocialConnect.module.scss';

const SocialConnect = () => {
    const router = useRouter();
    const [query, setQuery] = useState(null);
    const { addToast } = useToasts();
    const { t } = useTranslateLpc('common');

    useEffect(() => {
        setQuery(router.query?.potRef);
    }, [router.query?.potRef]);

    const onGoogleSuccess = (response) => {
        AuthService.googleConnect({ accessToken: response.tokenId })
            .then((res) => {
                if (res.data.needTfaActivation) {
                    return router.push({ pathname: getRoute(ROUTE.LPC.AUTH.TFA), query: router.query });
                }
                res.status === 200 && onLoginSuccess();
            })
            .catch((error) => {
                addToast(t(`errors.${error.code}`), {
                    appearance: 'error',
                    autoDismiss: true,
                });
            });
    };

    const onFacebookSuccess = (response) => {
        AuthService.facebookConnect({ accessToken: response.accessToken })
            .then((res) => {
                if (res.data.needTfaActivation) {
                    return router.push({ pathname: getRoute(ROUTE.LPC.AUTH.TFA), query: router.query });
                }
                res.status === 200 && onLoginSuccess();
            })
            .catch((error) => {
                addToast(t(`errors.${error.code}`), {
                    appearance: 'error',
                    autoDismiss: true,
                });
            });
    };

    const onLoginSuccess = () => {
        if (getItemFromStorage('session', 'temporaryPot')) {
            return router.push(getRoute(ROUTE.LPC.POT.CREATE_POT)).then();
        }
        if (query) {
            return router.push(getRoute(ROUTE.LPC.POT.POT, query, `?participate=${true}`)).then();
        }
        if (getItemFromStorage('local', 'payWithPot')) {
            return router
                .push(getRoute(ROUTE.LPC.POT.SPENDING_PARTNER_LIMONETIK, getItemFromStorage('local', 'payWithPot')))
                .then();
        }
        redirectAfterLogin();
    };

    const redirectAfterLogin = () => {
        if (router.query.urlReturn) {
            // @ts-ignore
            return window.location.assign(router.query.urlReturn);
        }
        AuthService.userHasPots()
            .then((res) => {
                res.data
                    ? router.push(getRoute(ROUTE.LPC.DASHBOARD.MY_POTS_CREATED)).then()
                    : router.push(getRoute(ROUTE.LPC.POT.CREATE_POT)).then();
            })
            .catch(() => {
                router.push(getRoute(ROUTE.LPC.POT.CREATE_POT)).then();
            });
    };

    const onFailure = () => {};

    return (
        <div className={css.wrapper}>
            <AppleSignin
                authOptions={{
                    clientId: process.env.APPLE_CLIENT_ID,
                    scope: 'email name',
                    redirectURI: process.env.APPLE_REDIRECT_URI,
                    state: '',
                    nonce: 'nonce',
                    usePopup: false,
                }}
                noDefaultStyle
                buttonExtraChildren=""
                skipScript={false}
                render={(props) => (
                    <button className={css.apple} {...props}>
                        <img src="/front-static/icons/logo/apple.svg" alt="apple logo" />
                    </button>
                )}
                onError={() => {}}
                onSuccess={() => {}}
                uiType={'light'}
            />

            <GoogleLogin
                clientId={process.env.GOOGLE_APP_ID}
                buttonText="LoginSlider"
                onSuccess={onGoogleSuccess}
                onFailure={onFailure}
                render={({ onClick }) => (
                    <div className={css.google} onClick={onClick}>
                        <img src="/front-static/icons/logo/google.svg" alt="google connect" />
                    </div>
                )}
            />

            <FacebookLogin
                appId={process.env.FACEBOOK_APP_ID}
                autoLoad={false}
                fields="name,email,picture"
                callback={onFacebookSuccess}
                render={({ onClick }) => (
                    <div className={css.facebook} onClick={onClick}>
                        <img src="/front-static/icons/logo/facebook.svg" alt="facebook logo" />
                    </div>
                )}
            />
        </div>
    );
};
export default SocialConnect;
